module.exports = __webpack_public_path__ + "img/qrcode_temp_1.c9e4fa3c.svg";